export default __webpack_public_path__ + "static/media/picklebadge.2656fcd2.png";